import { ReactNode, useContext, createContext } from "preact/compat";
import { BrowserBranding } from "./types.ts";

const context = createContext<BrowserBranding | undefined>(undefined);

type BrandingProviderProps = {
	readonly branding: BrowserBranding;
	readonly children: ReactNode;
};

function BrandingProvider({ branding, children }: BrandingProviderProps) {
	return <context.Provider value={branding}>{children}</context.Provider>;
}

function useBranding() {
	const value = useContext(context);
	if (value === undefined) {
		throw new Error("No branding context");
	}
	return value;
}

export { useBranding, BrandingProvider };
